<template lang="pug">
  .jobs-favorites
    .content-wrap
      .container
        .offers-container
          .offer-wrap(
          v-for="(item, index) in offers.items"
          :key="item.index"
          )
            router-link.offer(:to="{name: 'Vacancy', params: {lang: getLanguage, id: item.id, previous: $route}}")
              .count {{getListNumber(index)}}.
              .img(:style="{'background-image': item.image_urls ? `url(${item.image_urls.wide_mid})` : ''}")
              .text
                .nationality: strong {{gettext('Vacancy')}}: &nbsp;
                span {{ item.name }}
              .mdi.mdi-delete.icon-delete(@click.prevent="deleteFavorite(item.id)")
        vue-paginate(
        v-if="offers.total_items"
        :page-count="offers.total_pages"
        :page-range="pageSize"
        :initial-page="currentPage-1"
        :clickHandler="toPage"
        )
        h3.nothing(v-else) Nothing yet
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import VuePaginate from '@/components/paginate'
import { gettext } from '@/services/TranslateHandler'

export default {
  name: 'favoritesJobs',
  data () {
    return {
      offers: {},
      pageSize: 10,
      currentPage: parseInt(this.$route.query.page) || 1
    }
  },
  components: {
    VuePaginate
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'getFavoriteVacancies',
      'deleteVacancyFromfavorites'
    ]),
    getOffers () {
      this.getFavoriteVacancies({lang: this.getLanguage, pageNum: this.currentPage, pageSize: this.pageSize}).then(res => {
        this.offers = res
      })
    },
    deleteFavorite (id) {
      this.deleteVacancyFromfavorites({id: id}).then(res => {
        this.getOffers()
      })
    },
    toPage (page) {
      this.currentPage = +page
      this.getOffers()
    },
    getListNumber (index) {
      return (this.currentPage - 1) * this.$store.state.pageSize + index + 1
    }
  },
  computed: {
    ...mapGetters(['getLanguage'])
  },
  created () {
    this.getOffers()
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/favorites/jobs/index.vue